import { EnumPessoaTipo } from "../../Pessoa/Pessoa";
import { TypeAluno } from "../Pessoa/Aluno"
import { TypeEscola } from "../Pessoa/Escola"
import { TypeResponsavel } from "../Pessoa/Responsavel"

export enum EnumTipoUsuario { 
  Escola = EnumPessoaTipo.ESCOLA,
  Responsavel = EnumPessoaTipo.RESPONSAVEL,
  Aluno = EnumPessoaTipo.ALUNO
}

export type SessaoARDaEscola = {
  token?: string;
  usuario?: TypeUsuarioDaAreaRestrita;
  tipoDeUsuario?: EnumTipoUsuario.Escola;
  info?: TypeEscola;
}

export type SessaoARDoResponsavel = {
  token?: string;
  usuario?: TypeUsuarioDaAreaRestrita;
  tipoDeUsuario?: EnumTipoUsuario.Responsavel;
  info?: TypeResponsavel;
}

export type SessaoARDoAluno = {
  token?: string;
  usuario?: TypeUsuarioDaAreaRestrita;
  tipoDeUsuario?: EnumTipoUsuario.Aluno;
  info?: TypeAluno;
}

export type TypeSessaoDaAreaRestrita = SessaoARDoResponsavel | SessaoARDaEscola | SessaoARDoAluno;